/**
 * =========================================================
 * FloatingVideoCall — PiP (Picture-in-Picture) global
 * =========================================================
 * Çfarë bën: Shfaqet fixed bottom-right kur ka thirrje aktive
 *            dhe user-i është JASHTË /app/messages.
 *            Kur user-i është te /messages → ChatWindow e mbulon.
 *            Kjo komponente persist-on iframe-in gjatë navigimit.
 * Vendoset: AppShell, jashtë <Outlet /> → persist-on gjithmonë.
 * =========================================================
 */

import { Maximize2, X } from "lucide-react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useVideoCallStore } from "@/lib/stores/videoCallStore";

export const FloatingVideoCall = (): JSX.Element | null => {
  const { meetingLink, endPiP } = useVideoCallStore();
  const location = useLocation();
  const [minimized, setMinimized] = useState(false);

  // Mos shfaq te /app/messages — ChatWindow ka iframen atje
  const isOnMessages = location.pathname.includes("/messages");
  if (!meetingLink || isOnMessages) return null;

  return (
    <div
      className={[
        "fixed bottom-5 right-5 z-[300] overflow-hidden rounded-[20px]",
        "border border-sky-400/30 bg-[#0a0f1e] shadow-[0_8px_40px_rgba(0,0,0,0.5)]",
        minimized ? "h-12 w-64" : "h-[240px] w-[360px]",
        "transition-all duration-300",
      ].join(" ")}
    >
      {/* Header PiP */}
      <div className="flex shrink-0 items-center gap-2 bg-[#0d1526]/90 px-3 py-2">
        <span className="flex h-2 w-2 animate-pulse rounded-full bg-rose-500 shadow-[0_0_6px_rgba(239,68,68,0.8)]" aria-hidden="true" />
        <span className="flex-1 truncate text-[11px] font-bold uppercase tracking-widest text-white/70">
          LIVE · Thirrja Video
        </span>
        <button
          type="button"
          onClick={() => setMinimized((m) => !m)}
          className="rounded-md p-1 text-muted-foreground hover:bg-card/10 hover:text-white transition-colors"
          aria-label={minimized ? "Zgjero" : "Minimizo"}
        >
          <Maximize2 className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
        <button
          type="button"
          onClick={endPiP}
          className="rounded-md p-1 text-muted-foreground hover:bg-rose-500/20 hover:text-rose-300 transition-colors"
          aria-label="Mbyll thirrjen"
        >
          <X className="h-3.5 w-3.5" aria-hidden="true" />
        </button>
      </div>

      {/* Jitsi iframe — persist-on gjatë navigimit */}
      {!minimized && (
        <iframe
          className="h-[calc(100%-40px)] w-full border-0"
          src={`${meetingLink}#config.prejoinPageEnabled=false&config.startWithAudioMuted=false`}
          allow="camera; microphone; display-capture; fullscreen; autoplay"
          allowFullScreen
          title="Thirrja Video (PiP)"
        />
      )}
    </div>
  );
};

// =========================================================
// Fund i FloatingVideoCall
// =========================================================
